import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "user-add-page common-page"
};
const _hoisted_2 = {
  class: "fixed-header"
};
const _hoisted_3 = {
  class: "header-left"
};
const _hoisted_4 = {
  class: "header-right"
};
const _hoisted_5 = {
  class: "past-history-section"
};
const _hoisted_6 = {
  class: "family-history-container"
};
const _hoisted_7 = {
  class: "add-button-wrapper"
};
const _hoisted_8 = {
  class: "selected-items"
};
const _hoisted_9 = {
  class: "family-history-container"
};
const _hoisted_10 = {
  class: "add-button-wrapper"
};
const _hoisted_11 = {
  class: "selected-items"
};
const _hoisted_12 = {
  class: "medication-container"
};
const _hoisted_13 = {
  class: "add-button-container"
};
const _hoisted_14 = {
  class: "medication-list"
};
const _hoisted_15 = {
  class: "medication-row"
};
const _hoisted_16 = {
  class: "medication-header"
};
const _hoisted_17 = {
  class: "medication-name"
};
const _hoisted_18 = {
  class: "medication-detail"
};
const _hoisted_19 = {
  class: "family-history-container"
};
const _hoisted_20 = {
  class: "add-button-wrapper"
};
const _hoisted_21 = {
  class: "selected-items"
};
import { reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import SeparateUpload from "@/components/separate-upload.vue";
import PastDialog from "./components/past-dialog.vue";
import { getHealthUserListApi } from "@/service/modules/role";
import { ElMessage } from "element-plus";
import { addProjectApi, getProjectDescApi } from "@/service/modules/user";
import PastFlatList from "./components/past-flat-list.vue";
import MultiSelectDialog from "./components/multi-select-dialog.vue";
import { safeParseJSON } from "@/utils/math";
import { getDictListById } from "@/service/modules/dict";
export default /*@__PURE__*/_defineComponent({
  __name: 'add',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const pastDialogVisible = ref(false);
    const pastDialogType = ref("add");
    const pastDialogItemData = ref({});
    const pastDialogIndex = ref(null);
    const isLoading = ref(false);
    const healthUserList = ref([]);
    const baseRef = ref();
    const id = ref(null);
    const typeList = ref([]);
    const occupationList = ref([]);
    const sleepStatusList = ref([]);
    const bodyTypeList = ref([]);
    const nutritionStatusList = ref([]);
    const exerciseHabitsList = ref([]);
    const dietaryHabitsList = ref([]);
    const smokingStatusList = ref([]);
    const alcoholConsumptionList = ref([]);
    const excretionStatusList = ref([]);
    const familyHistoryOptions = ref([]);
    const familyHistoryDialogVisible = ref(false);
    const mainComplaintOptions = ref([]);
    const allergyHistoryOptions = ref([]);
    const mainComplaintDialogVisible = ref(false);
    const allergyHistoryDialogVisible = ref(false);
    const medicationOptions = ref([]);
    const medicationDialogVisible = ref(false);
    let baseForm = reactive({
      fileNumber: "",
      // 档案编号
      creation_time: "",
      // 建档时间
      photo: "",
      // 照片
      healthManager: "",
      // 健康管理师
      name: "",
      // 姓名
      familyMember: "",
      // 档案归属
      gender: "",
      // 性别
      bloodType: "",
      // 血型
      birthdate: "",
      // 出生年月
      age: "",
      // 年龄
      ethnicity: "",
      // 民族
      address: "",
      // 家庭住址
      mobile: "",
      // 本人电话
      phoneNumber: "",
      // 家属联系电话
      occupation: "",
      // 职业
      maritalStatus: "",
      // 婚姻状况
      temperature: "",
      //体温
      pulse: "",
      // 脉搏
      breathing: "",
      // 呼吸
      bloodPressure: "",
      // 血压
      height: "",
      // 身高
      weight: "",
      // 体重
      bloodSugar: "",
      // 血糖
      bodyType: "",
      // 体型
      nutritionStatus: "",
      // 营养状况
      exerciseHabits: "",
      // 体育锻炼
      dietaryHabits: "",
      // 饮食习惯
      sleepStatus: "",
      // 睡眠情况
      smokingStatus: "",
      // 吸烟情况
      alcoholConsumption: "",
      // 饮酒情况
      pastMedicalHistory: [],
      // 既往病史
      currentMedicalHistory: [],
      // 现病史
      familyHistory: [],
      // 家族病史
      medicationHistory: [],
      // 用药情况改为对象数组[{name: '药名', value: '详情'}]
      allergyHistory: [],
      // 过敏史
      selfEvaluation: "",
      // 自我评估
      mainHealthIssues: "",
      // 现存的主要健康问题及隐患
      excretionStatus: "" // 排泄情况
    });
    const baseRules = {
      name: [{
        required: true,
        message: "请输入姓名",
        trigger: "blur"
      }],
      familyMember: [{
        required: true,
        message: "请选择档案归属",
        trigger: "change"
      }],
      mobile: [{
        required: true,
        message: "请输入手机号码",
        trigger: "blur"
      }, {
        pattern: /^1[3456789]\d{9}$/gi,
        message: "请输入正确的手机格式",
        trigger: "blur"
      }],
      phoneNumber: [{
        pattern: /^1[3456789]\d{9}$/gi,
        message: "请输入正确的手机格式",
        trigger: "blur"
      }]
    };
    // 获取健康师列表
    getHealthUserList();
    async function getHealthUserList() {
      try {
        let res = await getHealthUserListApi();
        healthUserList.value = res.data.users.filter(item => item.status === 1);
      } catch {}
    }
    // 获取关系列表
    getTypeList();
    async function getTypeList() {
      try {
        // let { data } = await getTypeListApi();
        let {
          data
        } = await getDictListById(1);
        typeList.value = data.map(item => item.name); //档案归属
      } catch {}
      try {
        let {
          data
        } = await getDictListById(2);
        occupationList.value = data.map(item => item.name); //婚姻状况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(3);
        sleepStatusList.value = data.map(item => item.name); //睡眠情况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(4);
        excretionStatusList.value = data.map(item => item.name); //排泄情况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(7);
        mainComplaintOptions.value = data.map(item => item.name); //主诉
      } catch {}
      try {
        let {
          data
        } = await getDictListById(8);
        familyHistoryOptions.value = data.map(item => item.name); //家族病史
      } catch {}
      try {
        let {
          data
        } = await getDictListById(9);
        medicationOptions.value = data.map(item => item.name); //用药情况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(10);
        allergyHistoryOptions.value = data.map(item => item.name); //过敏史
      } catch {}
      try {
        let {
          data
        } = await getDictListById(11);
        bodyTypeList.value = data.map(item => item.name); //体型
      } catch {}
      try {
        let {
          data
        } = await getDictListById(12);
        nutritionStatusList.value = data.map(item => item.name); //营养状况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(13);
        exerciseHabitsList.value = data.map(item => item.name); //体育锻炼
      } catch {}
      try {
        let {
          data
        } = await getDictListById(14);
        dietaryHabitsList.value = data.map(item => item.name); //饮食习惯
      } catch {}
      try {
        let {
          data
        } = await getDictListById(15);
        smokingStatusList.value = data.map(item => item.name); //吸烟情况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(16);
        alcoholConsumptionList.value = data.map(item => item.name); //饮酒情况
      } catch {}
    }
    // 上传照片
    function handleUploadImg(img) {
      baseForm.photo = img;
    }
    // 出生年月变化
    function handleBirthdateChange(val) {
      let currentYear = new Date().getFullYear();
      let year = new Date(val).getFullYear();
      let month = new Date(val).getMonth() + 1;
      let date = new Date(val).getDate();
      let birthdate = `${year}/${month}/${date} 00:00:00`;
      baseForm.birthdate = new Date(birthdate).getTime();
      baseForm.age = (currentYear - year).toString();
    }
    // 添加既往病史
    function handleOpenPastDialogByAdd() {
      pastDialogVisible.value = true;
      pastDialogType.value = "add";
      pastDialogIndex.value = null;
      pastDialogItemData.value = {};
    }
    // 修改既往病史
    function handleOpenPastDialogByEdit(item, index) {
      pastDialogVisible.value = true;
      pastDialogType.value = "edit";
      pastDialogItemData.value = item;
      pastDialogIndex.value = index;
    }
    // 删除单个既往病史
    function handleDeletePast(index) {
      baseForm.pastMedicalHistory.splice(index, 1);
    }
    // 关闭既往病史弹窗
    function handleClosePastDialog() {
      pastDialogVisible.value = false;
      pastDialogType.value = "add";
      pastDialogIndex.value = null;
      pastDialogItemData.value = {};
    }
    // 保存既往病史信息
    function handleAddPastData(data) {
      if (pastDialogType.value === "edit" && pastDialogIndex.value !== null) {
        // 编辑
        baseForm.pastMedicalHistory[pastDialogIndex.value] = data;
      } else {
        // 添加
        baseForm.pastMedicalHistory.push(data);
      }
      handleClosePastDialog();
    }
    function handleToBack() {
      if (isLoading.value) return;
      router.back();
    }
    // 添加防抖函数
    const debounce = (fn, delay) => {
      let timer = null;
      return function (...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    };
    // 原始提交逻辑
    function originalHandleSubmit() {
      baseRef.value.validate(async valid => {
        if (valid) {
          // 将数组类型的字段转换为字符串格式
          const formData = {
            ...baseForm
          };
          // formData.pastMedicalHistory = JSON.stringify(formData.pastMedicalHistory);
          formData.familyHistory = JSON.stringify(formData.familyHistory);
          formData.medicationHistory = JSON.stringify(formData.medicationHistory);
          formData.allergyHistory = JSON.stringify(formData.allergyHistory);
          formData.currentMedicalHistory = JSON.stringify(formData.currentMedicalHistory);
          formData.sleepStatus = formData.sleepStatus.join("、");
          const params = {
            record: formData
          };
          console.log(123, "params", params);
          try {
            isLoading.value = true;
            let res = await addProjectApi(params);
            ElMessage.success("添加成功");
            setTimeout(() => {
              router.replace("/user/user");
            }, 500);
          } catch (e) {
            console.log("e", e);
          } finally {
            isLoading.value = false;
          }
        }
      });
    }
    // 使用防抖包装原始提交函数
    const handleSubmit = debounce(originalHandleSubmit, 1000);
    // 查看详情
    async function getProjectDesc() {
      try {
        let res = await getProjectDescApi(id.value);
        res.data.record.currentMedicalHistory = safeParseJSON(res.data.record.currentMedicalHistory);
        res.data.record.familyHistory = safeParseJSON(res.data.record.familyHistory);
        res.data.record.medicationHistory = safeParseJSON(res.data.record.medicationHistory);
        res.data.record.allergyHistory = safeParseJSON(res.data.record.allergyHistory);
        res.data.record.sleepStatus = res.data.record.sleepStatus ? res.data.record.sleepStatus.split("、") : [];
        baseForm = Object.assign(baseForm, res.data.record);
      } catch {}
    }
    onMounted(() => {
      let query = route.query;
      if (query.id) {
        id.value = query.id;
        getProjectDesc();
      }
    });
    function handlePastListAdd() {
      // 可以添加其他逻辑
    }
    function handlePastListDelete(index) {
      // 可以添加其他逻辑
    }
    function handleRemoveFamilyHistory(index) {
      const history = [...baseForm.familyHistory];
      history.splice(index, 1);
      baseForm.familyHistory = history;
    }
    function openFamilyHistoryDialog() {
      familyHistoryDialogVisible.value = true;
    }
    function handleRemoveMainComplaint(index) {
      const complaint = [...baseForm.currentMedicalHistory];
      complaint.splice(index, 1);
      baseForm.currentMedicalHistory = complaint;
    }
    function openMainComplaintDialog() {
      mainComplaintDialogVisible.value = true;
    }
    function handleRemoveAllergyHistory(index) {
      const allergy = [...baseForm.allergyHistory];
      allergy.splice(index, 1);
      baseForm.allergyHistory = allergy;
    }
    function openAllergyHistoryDialog() {
      allergyHistoryDialogVisible.value = true;
    }
    function handleRemoveMedication(index) {
      baseForm.medicationHistory.splice(index, 1);
    }
    function openMedicationDialog() {
      medicationDialogVisible.value = true;
    }
    function handleMedicationConfirm(selectedMeds) {
      // 检查是否有新增的药物
      selectedMeds.forEach(med => {
        const exists = baseForm.medicationHistory.some(item => item.name === med);
        if (!exists) {
          baseForm.medicationHistory.push({
            name: med,
            value: ""
          });
        }
      });
      // 移除已不在选择列表中的药物
      baseForm.medicationHistory = baseForm.medicationHistory.filter(item => selectedMeds.includes(item.name));
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_Delete = _resolveComponent("Delete");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(id.value ? "修改档案" : "新增档案"), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        type: "danger",
        style: {
          "margin-right": "10px"
        },
        size: "default",
        onClick: handleToBack
      }, {
        default: _withCtx(() => _cache[39] || (_cache[39] = [_createTextVNode("取消")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        onClick: _unref(handleSubmit),
        loading: isLoading.value
      }, {
        default: _withCtx(() => _cache[40] || (_cache[40] = [_createTextVNode("提交")])),
        _: 1
      }, 8, ["onClick", "loading"])])]), _createElementVNode("div", null, [_cache[50] || (_cache[50] = _createElementVNode("div", {
        class: "header flex"
      }, [_createElementVNode("div", {
        class: "line"
      }), _createElementVNode("div", {
        class: "label"
      }, "基本信息")], -1)), _createVNode(_component_el_form, {
        ref_key: "baseRef",
        ref: baseRef,
        model: _unref(baseForm),
        rules: baseRules,
        "label-width": "130px",
        "label-suffix": "：",
        class: "form-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "档案编号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).fileNumber,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(baseForm).fileNumber = $event),
                placeholder: "请输入档案编号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "姓名",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(baseForm).name = $event),
                placeholder: "请输入姓名",
                disabled: id.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "档案归属",
              prop: "familyMember"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).familyMember,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(baseForm).familyMember = $event),
                placeholder: "请选择档案归属",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "健康管理师"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).healthManager,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(baseForm).healthManager = $event),
                placeholder: "请选择健康管理师",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(healthUserList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.uid,
                    label: item.realname,
                    value: item.realname
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "性别"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).gender,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(baseForm).gender = $event),
                placeholder: "请选择性别",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "男",
                  value: "男"
                }), _createVNode(_component_el_option, {
                  label: "女",
                  value: "女"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "血型"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).bloodType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(baseForm).bloodType = $event),
                placeholder: "请选择血型",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "A",
                  value: "A"
                }), _createVNode(_component_el_option, {
                  label: "B",
                  value: "B"
                }), _createVNode(_component_el_option, {
                  label: "O",
                  value: "O"
                }), _createVNode(_component_el_option, {
                  label: "AB",
                  value: "AB"
                }), _createVNode(_component_el_option, {
                  label: "RH",
                  value: "RH"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "出生日期"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                style: {
                  "width": "100%"
                },
                modelValue: _unref(baseForm).birthdate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(baseForm).birthdate = $event),
                type: "date",
                onChange: handleBirthdateChange,
                placeholder: "请选择出生日期"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "年龄"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).age,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(baseForm).age = $event),
                disabled: "",
                placeholder: "请选择出生日期"
              }, {
                append: _withCtx(() => _cache[41] || (_cache[41] = [_createTextVNode("岁")])),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "民族"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).ethnicity,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(baseForm).ethnicity = $event),
                placeholder: "请输入选择民族",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "汉族",
                  value: "汉族"
                }), _createVNode(_component_el_option, {
                  label: "满族",
                  value: "满族"
                }), _createVNode(_component_el_option, {
                  label: "蒙古族",
                  value: "蒙古族"
                }), _createVNode(_component_el_option, {
                  label: "回族",
                  value: "回族"
                }), _createVNode(_component_el_option, {
                  label: "藏族",
                  value: "藏族"
                }), _createVNode(_component_el_option, {
                  label: "维吾尔族",
                  value: "维吾尔族"
                }), _createVNode(_component_el_option, {
                  label: "苗族",
                  value: "苗族"
                }), _createVNode(_component_el_option, {
                  label: "彝族",
                  value: "彝族"
                }), _createVNode(_component_el_option, {
                  label: "壮族",
                  value: "壮族"
                }), _createVNode(_component_el_option, {
                  label: "汉族",
                  value: "汉族"
                }), _createVNode(_component_el_option, {
                  label: "布依族",
                  value: "布依族"
                }), _createVNode(_component_el_option, {
                  label: "侗族",
                  value: "侗族"
                }), _createVNode(_component_el_option, {
                  label: "瑶族",
                  value: "瑶族"
                }), _createVNode(_component_el_option, {
                  label: "白族",
                  value: "白族"
                }), _createVNode(_component_el_option, {
                  label: "土家族",
                  value: "土家族"
                }), _createVNode(_component_el_option, {
                  label: "哈尼族",
                  value: "哈尼族"
                }), _createVNode(_component_el_option, {
                  label: "哈萨克族",
                  value: "哈萨克族"
                }), _createVNode(_component_el_option, {
                  label: "傣族",
                  value: "傣族"
                }), _createVNode(_component_el_option, {
                  label: "黎族",
                  value: "黎族"
                }), _createVNode(_component_el_option, {
                  label: "傈僳族",
                  value: "傈僳族"
                }), _createVNode(_component_el_option, {
                  label: "佤族",
                  value: "佤族"
                }), _createVNode(_component_el_option, {
                  label: "高山族",
                  value: "高山族"
                }), _createVNode(_component_el_option, {
                  label: "拉祜族",
                  value: "拉祜族"
                }), _createVNode(_component_el_option, {
                  label: "水族",
                  value: "水族"
                }), _createVNode(_component_el_option, {
                  label: "东乡族",
                  value: "东乡族"
                }), _createVNode(_component_el_option, {
                  label: "纳西族",
                  value: "纳西族"
                }), _createVNode(_component_el_option, {
                  label: "景颇族",
                  value: "景颇族"
                }), _createVNode(_component_el_option, {
                  label: "柯尔克孜族",
                  value: "柯尔克孜族"
                }), _createVNode(_component_el_option, {
                  label: "土族",
                  value: "土族"
                }), _createVNode(_component_el_option, {
                  label: "达斡尔族",
                  value: "达斡尔族"
                }), _createVNode(_component_el_option, {
                  label: "仫佬族",
                  value: "仫佬族"
                }), _createVNode(_component_el_option, {
                  label: "羌族",
                  value: "羌族"
                }), _createVNode(_component_el_option, {
                  label: "布朗族",
                  value: "布朗族"
                }), _createVNode(_component_el_option, {
                  label: "撒拉族",
                  value: "撒拉族"
                }), _createVNode(_component_el_option, {
                  label: "毛南族",
                  value: "毛南族"
                }), _createVNode(_component_el_option, {
                  label: "仡佬族",
                  value: "仡佬族"
                }), _createVNode(_component_el_option, {
                  label: "锡伯族",
                  value: "锡伯族"
                }), _createVNode(_component_el_option, {
                  label: "阿昌族",
                  value: "阿昌族"
                }), _createVNode(_component_el_option, {
                  label: "普米族",
                  value: "普米族"
                }), _createVNode(_component_el_option, {
                  label: "朝鲜族",
                  value: "朝鲜族"
                }), _createVNode(_component_el_option, {
                  label: "塔吉克族",
                  value: "塔吉克族"
                }), _createVNode(_component_el_option, {
                  label: "怒族",
                  value: "怒族"
                }), _createVNode(_component_el_option, {
                  label: "乌孜别克族",
                  value: "乌孜别克族"
                }), _createVNode(_component_el_option, {
                  label: "俄罗斯族",
                  value: "俄罗斯族"
                }), _createVNode(_component_el_option, {
                  label: "鄂温克族",
                  value: "鄂温克族"
                }), _createVNode(_component_el_option, {
                  label: "德昂族",
                  value: "德昂族"
                }), _createVNode(_component_el_option, {
                  label: "保安族",
                  value: "保安族"
                }), _createVNode(_component_el_option, {
                  label: "裕固族",
                  value: "裕固族"
                }), _createVNode(_component_el_option, {
                  label: "京族",
                  value: "京族"
                }), _createVNode(_component_el_option, {
                  label: "塔塔尔族",
                  value: "塔塔尔族"
                }), _createVNode(_component_el_option, {
                  label: "独龙族",
                  value: "独龙族"
                }), _createVNode(_component_el_option, {
                  label: "鄂伦春族",
                  value: "鄂伦春族"
                }), _createVNode(_component_el_option, {
                  label: "赫哲族",
                  value: "赫哲族"
                }), _createVNode(_component_el_option, {
                  label: "门巴族",
                  value: "门巴族"
                }), _createVNode(_component_el_option, {
                  label: "珞巴族",
                  value: "珞巴族"
                }), _createVNode(_component_el_option, {
                  label: "基诺族",
                  value: "基诺族"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "家庭住址"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).address,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(baseForm).address = $event),
                placeholder: "请输入家庭住址"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "联系电话",
              prop: "mobile"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).mobile,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(baseForm).mobile = $event),
                placeholder: "请输入手机号码",
                disabled: id.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }), _unref(baseForm).familyMember !== '本人' ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "家属联系电话",
              prop: "phoneNumber"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).phoneNumber,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(baseForm).phoneNumber = $event),
                placeholder: "请输入家属手机号码"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "当前职业"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).occupation,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(baseForm).occupation = $event),
                placeholder: "请选择当前职业",
                style: {
                  "width": "100%"
                },
                filterable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(occupationList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "婚姻状况"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).maritalStatus,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(baseForm).maritalStatus = $event),
                placeholder: "请选择婚姻状况",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "未婚",
                  value: "未婚"
                }), _createVNode(_component_el_option, {
                  label: "已婚",
                  value: "已婚"
                }), _createVNode(_component_el_option, {
                  label: "离婚",
                  value: "离婚"
                }), _createVNode(_component_el_option, {
                  label: "丧偶",
                  value: "丧偶"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "照片"
            }, {
              default: _withCtx(() => [_createVNode(SeparateUpload, {
                img1Url: _unref(baseForm).photo,
                onUploadSuccess: handleUploadImg
              }, null, 8, ["img1Url"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _cache[47] || (_cache[47] = _createElementVNode("div", {
          class: "header flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "生命特质")], -1)), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "体温（℃）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).temperature,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(baseForm).temperature = $event),
                placeholder: "请输入体温"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "脉搏（次/分）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).pulse,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(baseForm).pulse = $event),
                placeholder: "请输入脉搏"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "呼吸（次/分）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).breathing,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(baseForm).breathing = $event),
                placeholder: "请输入呼吸"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "血压（mmHg）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).bloodPressure,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(baseForm).bloodPressure = $event),
                placeholder: "请输入血压"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "身高（cm）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).height,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(baseForm).height = $event),
                placeholder: "请输入身高"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "体重（kg）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).weight,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(baseForm).weight = $event),
                placeholder: "请输入体重"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "血糖（mmol/L）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(baseForm).bloodSugar,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(baseForm).bloodSugar = $event),
                placeholder: "请输入血糖"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "体型"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).bodyType,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _unref(baseForm).bodyType = $event),
                placeholder: "请选择体型",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bodyTypeList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "营养状况"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).nutritionStatus,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _unref(baseForm).nutritionStatus = $event),
                placeholder: "请选择营养状况",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nutritionStatusList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "体育锻炼"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).exerciseHabits,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => _unref(baseForm).exerciseHabits = $event),
                placeholder: "请选择体育锻炼",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exerciseHabitsList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "饮食习惯"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).dietaryHabits,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _unref(baseForm).dietaryHabits = $event),
                placeholder: "请选择饮食习惯",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dietaryHabitsList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "睡眠情况"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).sleepStatus,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => _unref(baseForm).sleepStatus = $event),
                placeholder: "请选择睡眠情况",
                style: {
                  "width": "100%"
                },
                multiple: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sleepStatusList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "吸烟情况"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).smokingStatus,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => _unref(baseForm).smokingStatus = $event),
                placeholder: "请选择吸烟情况",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smokingStatusList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "饮酒情况"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).alcoholConsumption,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => _unref(baseForm).alcoholConsumption = $event),
                placeholder: "请选择饮酒情况",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alcoholConsumptionList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "排泄情况"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(baseForm).excretionStatus,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => _unref(baseForm).excretionStatus = $event),
                placeholder: "请选择排泄情况",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excretionStatusList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _cache[48] || (_cache[48] = _createElementVNode("div", {
          class: "header flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "病史信息")], -1)), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[42] || (_cache[42] = _createElementVNode("div", {
              class: "past-history-label"
            }, "既往病史", -1)), _createVNode(PastFlatList, {
              value: _unref(baseForm).pastMedicalHistory,
              "onUpdate:value": _cache[29] || (_cache[29] = $event => _unref(baseForm).pastMedicalHistory = $event),
              onAdd: handlePastListAdd,
              onDelete: handlePastListDelete
            }, null, 8, ["value"])])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "主诉"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
                class: "add-button",
                type: "primary",
                size: "small",
                plain: "",
                onClick: openMainComplaintDialog
              }, {
                default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode(" 添加 ")])),
                _: 1
              })]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(baseForm).currentMedicalHistory, (item, index) => {
                return _openBlock(), _createBlock(_component_el_tag, {
                  key: index,
                  closable: "",
                  onClose: $event => handleRemoveMainComplaint(index),
                  class: "history-tag"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["onClose"]);
              }), 128))])])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "家族病史"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
                class: "add-button",
                type: "primary",
                size: "small",
                plain: "",
                onClick: openFamilyHistoryDialog
              }, {
                default: _withCtx(() => _cache[44] || (_cache[44] = [_createTextVNode(" 添加 ")])),
                _: 1
              })]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(baseForm).familyHistory, (item, index) => {
                return _openBlock(), _createBlock(_component_el_tag, {
                  key: index,
                  closable: "",
                  onClose: $event => handleRemoveFamilyHistory(index),
                  class: "history-tag"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["onClose"]);
              }), 128))])])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "用药情况"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                plain: "",
                class: "add-button",
                onClick: openMedicationDialog
              }, {
                default: _withCtx(() => _cache[45] || (_cache[45] = [_createTextVNode(" 添加 ")])),
                _: 1
              })]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(baseForm).medicationHistory, (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["medication-item", {
                    'is-last-row': index >= _unref(baseForm).medicationHistory.length - (_unref(baseForm).medicationHistory.length % 3 || 3)
                  }])
                }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(item.name), 1), _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  circle: "",
                  onClick: $event => handleRemoveMedication(index),
                  class: "delete-btn"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_Delete)]),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["onClick"])]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_input, {
                  modelValue: item.value,
                  "onUpdate:modelValue": $event => item.value = $event,
                  placeholder: "请输入用药详情（用量、频率等）",
                  size: "small"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])])], 2);
              }), 128))])])])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "过敏史"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_button, {
                class: "add-button",
                type: "primary",
                size: "small",
                plain: "",
                onClick: openAllergyHistoryDialog
              }, {
                default: _withCtx(() => _cache[46] || (_cache[46] = [_createTextVNode(" 添加 ")])),
                _: 1
              })]), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(baseForm).allergyHistory, (item, index) => {
                return _openBlock(), _createBlock(_component_el_tag, {
                  key: index,
                  closable: "",
                  onClose: $event => handleRemoveAllergyHistory(index),
                  class: "history-tag"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["onClose"]);
              }), 128))])])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _cache[49] || (_cache[49] = _createElementVNode("div", {
          class: "header flex"
        }, [_createElementVNode("div", {
          class: "line"
        }), _createElementVNode("div", {
          class: "label"
        }, "其他信息")], -1)), _createVNode(_component_el_form, {
          ref: "otherRef",
          model: _unref(baseForm),
          "label-width": "130px",
          "label-suffix": "：",
          class: "form-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "自我评估"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(baseForm).selfEvaluation,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => _unref(baseForm).selfEvaluation = $event),
                  placeholder: "请选择自我评估",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "满意",
                    value: "满意"
                  }), _createVNode(_component_el_option, {
                    label: "基本满意",
                    value: "基本满意"
                  }), _createVNode(_component_el_option, {
                    label: "说不清楚",
                    value: "说不清楚"
                  }), _createVNode(_component_el_option, {
                    label: "不太满意",
                    value: "不太满意"
                  }), _createVNode(_component_el_option, {
                    label: "不满意",
                    value: "不满意"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "现存健康问题"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  rows: 3,
                  type: "textarea",
                  modelValue: _unref(baseForm).mainHealthIssues,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => _unref(baseForm).mainHealthIssues = $event),
                  placeholder: "请输入现存的主要健康问题及隐患"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model"])])]), _createVNode(PastDialog, {
        dialogVisible: pastDialogVisible.value,
        dialogType: pastDialogType.value,
        itemData: pastDialogItemData.value,
        onCloseDialog: handleClosePastDialog,
        onRestData: handleAddPastData
      }, null, 8, ["dialogVisible", "dialogType", "itemData"]), _createVNode(MultiSelectDialog, {
        visible: familyHistoryDialogVisible.value,
        "onUpdate:visible": _cache[32] || (_cache[32] = $event => familyHistoryDialogVisible.value = $event),
        value: _unref(baseForm).familyHistory,
        "onUpdate:value": _cache[33] || (_cache[33] = $event => _unref(baseForm).familyHistory = $event),
        options: familyHistoryOptions.value,
        title: "选择家族病史"
      }, null, 8, ["visible", "value", "options"]), _createVNode(MultiSelectDialog, {
        visible: mainComplaintDialogVisible.value,
        "onUpdate:visible": _cache[34] || (_cache[34] = $event => mainComplaintDialogVisible.value = $event),
        value: _unref(baseForm).currentMedicalHistory,
        "onUpdate:value": _cache[35] || (_cache[35] = $event => _unref(baseForm).currentMedicalHistory = $event),
        options: mainComplaintOptions.value,
        title: "选择主诉"
      }, null, 8, ["visible", "value", "options"]), _createVNode(MultiSelectDialog, {
        visible: allergyHistoryDialogVisible.value,
        "onUpdate:visible": _cache[36] || (_cache[36] = $event => allergyHistoryDialogVisible.value = $event),
        value: _unref(baseForm).allergyHistory,
        "onUpdate:value": _cache[37] || (_cache[37] = $event => _unref(baseForm).allergyHistory = $event),
        options: allergyHistoryOptions.value,
        title: "选择过敏史"
      }, null, 8, ["visible", "value", "options"]), _createVNode(MultiSelectDialog, {
        visible: medicationDialogVisible.value,
        "onUpdate:visible": _cache[38] || (_cache[38] = $event => medicationDialogVisible.value = $event),
        value: _unref(baseForm).medicationHistory.map(item => item.name),
        options: medicationOptions.value,
        title: "选择用药情况",
        onConfirm: handleMedicationConfirm
      }, null, 8, ["visible", "value", "options"])], 64);
    };
  }
});